import { isNotDefined, isNotEmpty } from '@terros/common'
import { usePreference } from '../preferences'

export type CanEditAddressDetailsInput = {
  allowDetailEdits: boolean
  blocksEdits: boolean
  isCheckingBlock: boolean
}

/** Detail fields stay read-only while the check is in flight, and whenever the behavior is on. */
export function canEditAddressDetails(input: CanEditAddressDetailsInput): boolean {
  if (input.isCheckingBlock) return false
  if (input.blocksEdits) return false
  return input.allowDetailEdits
}

export type BlocksCustomLocationDetailEditsState = {
  blocksEdits: boolean
  isLoading: boolean
}

export type PreferenceDetailCheck = {
  isLoading: boolean
  error?: string
  data: boolean | undefined
}

/**
 * Loading, a failed preference read, or a finished read with no value all stay unresolved.
 * Callers treat that like loading and keep address details locked.
 */
export function isPreferenceDetailCheckUnresolved(input: PreferenceDetailCheck): boolean {
  if (input.isLoading) return true
  if (isNotEmpty(input.error)) return true
  return isNotDefined(input.data)
}

export function useBlocksCustomLocationDetailEdits(): BlocksCustomLocationDetailEditsState {
  const preference = usePreference('blockCustomLocationDetailEdits')
  const preferenceUnresolved = isPreferenceDetailCheckUnresolved({
    isLoading: preference.isLoading,
    error: preference.error,
    data: preference.data,
  })
  return {
    isLoading: preferenceUnresolved,
    blocksEdits: preference.data === true,
  }
}
